/**
 * Supported image sizes.
 * @enum {string}
 */
export const IllustrationSize = {
  SMALL: '200x172',
  LARGE: '900x772',
};

/**
 * Supported image options
 * @enum {string}
 */
export const IllustrationOption = {
  FIRST_OPTION: '03',
  SECOND_OPTION: '04',
  THIRD_OPTION: '05',
};

/**
 * Builds the illustration image url.
 * @param {string} fileName The name of the image
 * @param {IllustrationSizes} size The dimensions of the image
 * @param {string} number The image number
 * @param {boolean} isWatermark Indicates if the image should be loaded as watermark or not
 */
export default function buildIllustrationImageUrl(fileName, size, number, isWatermark) {
  const watermark = isWatermark ? 'w-' : '';

  return `${process.env.SVG_PUBLIC_URL}realistic/${fileName}/${size}/${watermark}${fileName}-${number}.png`;
}
